import React from "react";
import { Link } from "react-router-dom";
import "../styles/about.css";

export default function About() {
  return (
    <div className="page about">

      {/* HERO */}
      <section className="hero hero--about">
        <div className="hero__overlay" />
        <div className="container hero__content hero__content--center">
          <h1 className="hero__title">
            We Are Changing the Way Ontario Experiences the Outdoors
          </h1>
          <p className="hero__subtitle">
            Try Play Go is more than a membership service. We are a movement toward
            accessible, affordable recreation for everyone.
          </p>
          <Link to="/clubs" className="btn btn--primary">
            Join the Revolution
          </Link>
        </div>
      </section>

      {/* OUR STORY */}
      <section className="section">
        <div className="container split">
          <div>
            <h2>Our Story</h2>
            <p>
              Eighteen years ago, The Power Garage started with a simple idea around
              a family kitchen table in Woodstock, Ontario. What began as a small
              dealership has grown into a four-division operation spanning RVs,
              Marine, Powersports, and Equipment.
            </p>
            <p>
              Along the way, we heard the same thing again and again — ownership
              doesn’t work for everyone. The cost, storage, maintenance, and
              commitment were holding people back from experiencing the outdoors.
            </p>
            <p>
              That realization sparked something bigger.
            </p>
          </div>
          <img
            src="https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/About/old%20location.png"
            alt="Family enjoying RV at sunset"
          />
        </div>
      </section>

      {/* BIRTH OF TPG */}
      <section className="section section--alt">
        <div className="container split reverse">
          <img
            src="https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/About/current%20location.png"
            alt="Try Play Go vehicle fleet"
          />
          <div>
            <h2>The Birth of Try Play Go</h2>
            <p>
              In 2025, we launched Try Play Go — not as a rental service, but as a
              membership platform. One membership. An entire fleet. Zero ownership
              headaches.
            </p>
            <ul className="bullets">
              <li>Recreation should be accessible</li>
              <li>Variety enhances the experience</li>
              <li>Support makes all the difference</li>
            </ul>
          </div>
        </div>
      </section>

      {/* MISSION / VISION */}
<section className="section">
  <div className="container grid-3">
    
    <div className="card">
      <h3>Our Purpose</h3>
      <p>
        Everything we do begins with a simple belief: life is better when it is
        filled with adventure. Try Play Go exists to help people pursue their
        dreams of exploration by making outdoor recreation more accessible,
        flexible, and rewarding than traditional ownership.
      </p>
    </div>

    <div className="card">
      <h3>Our Core Focus</h3>
      <p>
        Our philosophy is built around three pillars — <strong>Dreams,
        Experiences, and Memories</strong>. We help members turn the adventures
        they imagine into real experiences, and ultimately into lifelong
        memories shared with family and friends.
      </p>
    </div>

    <div className="card">
      <h3>Our Values</h3>
      <p>
        We operate with respect, reliability, passion, commitment, and
        community. We treat every member with genuine care, follow through on
        what we promise, bring energy and solutions to every challenge, and work
        together to build a community centered around adventure and the outdoors.
      </p>
    </div>

  </div>
</section>

      {/* WHAT MAKES US DIFFERENT */}
      <section className="section section--alt">
        <div className="container">
          <h2>What Makes Us Different</h2>
          <div className="grid-2">
            <div className="feature">
              <h4>Built by Industry Experts</h4>
              <p>
                Backed by 18 years at The Power Garage, we know these vehicles
                inside and out.
              </p>
            </div>
            <div className="feature">
              <h4>We Own Our Fleet</h4>
              <p>
                No cheap rentals. Every unit is hand-selected, maintained, and
                ready for adventure.
              </p>
            </div>
            <div className="feature">
              <h4>Concierge Service</h4>
              <p>
                Route planning, recommendations, and real support — not just keys
                and paperwork.
              </p>
            </div>
            <div className="feature">
              <h4>Membership, Not Rental</h4>
              <p>
                Predictable pricing, priority access, and a community you belong to.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FACILITY */}
      <section className="section">
        <div className="container split">
          <div>
            <h2>Our Facility</h2>
            <p>
              Our 5-acre, 10,000 sq/ft Woodstock headquarters is more than storage —
              it’s a recreation hub designed for members.
            </p>
            <ul className="bullets">
              <li>Member Lounge (Coming Soon)</li>
              <li>On-site service bays</li>
              <li>Gear & accessories shop</li>
              <li>Easy Highway 401 access</li>
            </ul>
          </div>
          <img
            src="https://tbmxmxpcuizrlrkkqmmm.supabase.co/storage/v1/object/public/About/current%20location%20(1).png"
            alt="Try Play Go facility"
          />
        </div>
      </section>

      

      {/* CTA */}
      <section className="section cta">
        <div className="container center">
          <h2>Join the Revolution</h2>
          <p>
            Try Play Go is building the future of recreation — and we’d love you to
            be part of it.
          </p>
          <Link to="/clubs" className="btn btn--primary btn--large">
            Explore Memberships
          </Link>
        </div>
      </section>

    </div>
  );
}
